import { useEffect, useState } from "react";
import { navItems } from "@/mocks/homeMeta";

interface TopBarProps {
  onOpenClue: () => void;
}

export default function TopBar({ onOpenClue }: TopBarProps) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-40 w-full border-b transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 border-background-200"
          : "bg-background-50 border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="h-16 flex items-center gap-4">
          <a href="#top" className="flex items-center gap-2.5 shrink-0 cursor-pointer">
            <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-search-eye-line text-lg w-5 h-5 flex items-center justify-center" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold text-foreground-950">
                蝌蚪黑料
              </span>
              <span className="text-[11px] font-label tracking-widest text-foreground-500 mt-0.5">
                辟谣 · 反转追踪
              </span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-1 mx-auto">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                className="px-3 py-2 text-sm font-label text-foreground-700 hover:text-primary-600 hover:bg-background-100 rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden xl:flex items-center gap-2 ml-auto bg-background-100 border border-background-200 rounded-md px-3 h-10 w-56">
            <i className="ri-search-line text-foreground-500 text-base w-4 h-4 flex items-center justify-center" />
            <input
              type="text"
              placeholder="搜事件、声明或关键词"
              className="w-full bg-transparent text-sm font-label text-foreground-900 placeholder:text-foreground-400 outline-none"
            />
          </div>

          <div className="flex items-center gap-2 ml-auto xl:ml-2">
            <button
              type="button"
              onClick={onOpenClue}
              className="hidden sm:inline-flex items-center gap-2 h-10 px-4 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-label transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-add-line text-base w-4 h-4 flex items-center justify-center" />
              提交线索
            </button>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setOpen((v) => !v)}
              className="lg:hidden w-10 h-10 rounded-md border border-background-200 text-foreground-800 flex items-center justify-center cursor-pointer"
            >
              <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-lg`} />
            </button>
          </div>
        </div>
      </div>

      {open ? (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <div className="flex items-center gap-2 bg-background-100 border border-background-200 rounded-md px-3 h-10 mb-3">
            <i className="ri-search-line text-foreground-500 text-base w-4 h-4 flex items-center justify-center" />
            <input
              type="text"
              placeholder="搜事件、声明或关键词"
              className="w-full bg-transparent text-sm font-label text-foreground-900 placeholder:text-foreground-400 outline-none"
            />
          </div>
          <div className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setOpen(false)}
                className="px-3 py-2.5 text-sm font-label text-foreground-700 bg-background-100 rounded-md text-center cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </div>
          <button
            type="button"
            onClick={() => {
              setOpen(false);
              onOpenClue();
            }}
            className="mt-3 w-full h-11 rounded-md bg-primary-500 text-background-50 text-sm font-label whitespace-nowrap cursor-pointer"
          >
            提交线索
          </button>
        </div>
      ) : null}
    </header>
  );
}